export default __webpack_public_path__ + "static/media/26.074891c0.jpg";